
import { CountryConfigResponse, ICountry, ICountryConfigRequest } from "@/entities";
import { IPageResponse } from "@/services";
import { ValidationObserver } from "vee-validate";
import Vue from "vue";
import Component from "vue-class-component";
import Multiselect from "vue-multiselect";
import { Getter } from "vuex-class";

@Component({
  name: "countries-page",
  components: {
    ValidationObserver,
    Multiselect,
  },
})
export default class CountriesPage extends Vue {
  @Getter("getCountriesPage") countriesPage!: IPageResponse<ICountry>;
  countrySelected: ICountry | null = null;
  countryOptions: ICountry[] = [];
  countryConfig: CountryConfigResponse | null = null;

  mounted(): void {
    const countries = this.countriesPage.content;
    if (countries) {
      this.countryOptions = countries;
    }
  }

  async onSelectCountry(country?: ICountry): Promise<void> {
    if (country) {
      const response = await this.$services.country.getCountryConfigByCode(country.code!);
      if (response) {
        this.countryConfig = response;
      } else {
        this.$swal.fire({
          icon: "info",
          title: this.$t("messages.country.config.not.exists") as string,
          showConfirmButton: false,
          timer: 1500,
        });
        this.countryConfig = this.initialCountryConfig();
      }
    }
  }

  initialCountryConfig(): CountryConfigResponse {
    return {
      enabledQueryFleetByPlate: false,
      enabledQueryFleetByInternalNumber: false,
      disabledExportEmployees: false,
      enabledOrderFlowApproval: false,
    };
  }

  async saveCountryConfig(): Promise<void> {
    if (this.countryConfig) {
      const countryCode = this.countrySelected?.code;
      const request: ICountryConfigRequest = {
        countryCode: countryCode || "",
        enabledQueryFleetByPlate: this.countryConfig.enabledQueryFleetByPlate || false,
        enabledQueryFleetByInternalNumber:
          this.countryConfig.enabledQueryFleetByInternalNumber || false,
        disabledExportEmployees: this.countryConfig.disabledExportEmployees || false,
        enabledOrderFlowApproval: this.countryConfig.enabledOrderFlowApproval || false,
      };
      const savedConfig = await this.$services.country.saveCountryConfig(request);
      if (savedConfig) {
        this.makeToast("success", this.$t("messages.config.saved.ok"));
      }
    }
  }

  makeToast(variant: string, message: string): void {
    this.$bvToast.toast(message, {
      autoHideDelay: 4000,
      variant,
      toaster: "b-toaster-bottom-center",
      noCloseButton: true,
    });
  }
}
